export Listing from './Listing';



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/global/containers/index.js